<template>
  <div class="classStudy" id="print">
    <!-- <el-card>
      <div class="classStudy-header">
        <el-cascader
          clearable
          v-model="courseIds"
          :show-all-levels="false"
          :props="subjectTreeProps"
          placeholder="请输入所属科目"
          :options="subjectTreeList"
        ></el-cascader>
        <el-button type="primary" class="classStudy-button" @click="addFormVisible=true" icon="el-icon-plus">添加模考</el-button>
      </div>
    </el-card>-->
    <el-card class="box-card">
      <p>初级会计职称第10期</p>
      <div class="paperManger">
        <el-button @click.stop="MassNotice()" :disabled="multipleSelection.length<=0">批量通知 <span v-if="multipleSelection.length>0">({{multipleSelection.length}})</span></el-button>
        <el-button @click.stop="MassRevice()" :disabled="multipleSelection.length<=0">批量领取 <span v-if="multipleSelection.length>0">({{multipleSelection.length}})</span></el-button>
        <el-button @click='batchPrint' :disabled="multipleSelection.length<=0">批量打印 <span v-if="multipleSelection.length>0">({{multipleSelection.length}})</span></el-button>
        <div class="classStudy-header" style="display:flex">
          <el-input placeholder="搜索准考证号/证件号" prefix-icon="el-icon-search" v-model="input1" style="margin-right:10px">
          </el-input>
          <el-input placeholder="搜索身份证号/手机号" prefix-icon="el-icon-search" v-model="input2">
          </el-input>
          <el-button type="primary" @click.stop="findData()" style="margin-left:10px;">进行查询</el-button>
        </div>
      </div>
      <div class="classStudy-table">
        <el-table ref="multipleTable" :data="studyDataList" style="width: 100%;" row-key="id" border @selection-change="handleSelectionChange">
          <el-table-column type="selection" min-width="40" align="center"></el-table-column>
          <el-table-column prop="studentName" show-overflow-tooltip label="姓名" align="center"></el-table-column>
          <el-table-column prop="mobile" label="手机号" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="credentialsName" label="证书名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="确认领取证书时间" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="状态" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="answer" label="操作" align="center" show-overflow-tooltip>
            <template slot-scope="scope">
              <i class="el-icon-chat-square" style="color: rgb(64, 158, 255);width: 100px;display: inline-block;text-align: center;" @click="sendMessage(scope.$index, scope.row)"></i>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next, jumper, total, sizes" style="margin-top: 20px;text-align: left;" :total="studyList.total" :page-size="studyList.pageSize" :page-sizes="[10, 20, 30, 40]" :current-page="studyList.pageNumber" @size-change="studySizeChange" @current-change="studyCurrentChange"></el-pagination>
      </div>

      <el-dialog title="编辑领取信息" :visible.sync="addFormVisible" width="30%" left>
        <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"> -->
        <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth">
          <el-row :span="24">
            <el-col :sm="24" :md="24" :lg="24">
              <el-radio v-model="radio" label="1">本人</el-radio>
              <el-radio v-model="radio" label="2">代领</el-radio>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align:right">
          <el-button @click.stop="resetCancel()">取消</el-button>
          <el-button type="primary" @click.stop="addSubmit">提 交</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog title="批量通知" :visible.sync="addFormVisiblePaper" width="35%" left>
      <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules"> -->
      <!-- <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" >
        <el-row >
          <el-col>
              <el-input
                type="textarea"
                :rows="3"
                v-model='massNotice'
                placeholder="请输入通知内容"
                auto-complete="on"
                maxlength="255"
              ></el-input>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:right">
        <el-button @click.stop="cancel()">取消</el-button>
        <el-button type="primary" @click.stop="submitPaper">提 交</el-button>
      </div>
    </el-dialog> -->
    </el-card>
    <Print ref="printDialog" :printData='printObjArr'></Print>
  </div>
</template>
<script>
import Print from './components/print'
export default {
  components: {
    Print
  },
  data () {
    return {
      input1: '',
      printObjArr: '',// 打印数组
      input2: '',
      pickerOptions: {
        shortcuts: [{
          text: "最近一周",
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近一个月",
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit("pick", [start, end]);
          }
        }, {
          text: "最近三个月",
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit("pick", [start, end]);
          }
        }]
      },
      value1: "",
      value2: "",
      startTime: "",
      endTime: "",
      allTime: '',
      courseTestIds: '',
      studyList: [],
      studyDataList: [],
      studySearch: {
        pageNumber: 1,
        pageSize: 10
      },
      subjectTreeProps: {
        isubjectId: "isubjectId",
        name: "name",
        children: "children"
      },
      formLabelWidth: "80px",
      subjectTreeList: [],
      subjectTreeListTime: [],
      courseIds: [],
      addForm: {},
      addFormVisible: false,
      addFormVisiblePaper: false,
      paperList: {
        "subjectId": 0,
        "sequence": 0,
        "pageSize": 10,
        "pageNumber": 1
      },
      timeValueFir: '',
      timeValueSec: '',
      editPaperData: {
        'id': '',
        'collectionTime': '',
        'collectionRemark': ''
      },
      valueList: {
        "pageSize": 10,
        "pageNumber": 1,
        "likename": 0,
        "examinationSettingId": 0
      },
      radio: '1',
      num: 0,
      dataList: [],
      idArr: [],
      multipleSelection: [],
      MassCourseNotice: [],
      massCouseNoticeList: {
        mobiles: []
      },
      massCouseNoticeInfoList: {
        mobiles: []
      },
      massNotice: '',
      noticeNum: 0
    }
  },
  computed: {},
  methods: {
    batchPrint () {
      var idArr = []
      this.multipleSelection.forEach(v => {
        idArr.push(v.id)
      })
      this.api.batchPrintProjectCerts({ examinationCredentialsId: idArr.join(',') }).then(res => {
        console.log(res.data)
        if (res.success) {
          this.printObjArr = res.data
          console.log('this.printObjArr', this.printObjArr.length, this.printObjArr)
          this.printObjArr.length > 0 ? this.$refs.printDialog.show(this.printObjArr) : ''
        }
      })
    },
    MassNotice () {
      if (this.dataList == '') {
        this.$message({
          message: '请选择列表!',
          type: 'warning'
        });
      } else {
        this.submitPaper()
      }
    },
    MassRevice () {
      if (this.dataList == '') {
        this.$message({
          message: '请选择列表!',
          type: 'warning'
        });
      } else {
        this.addFormVisible = true
      }
    },
    MassPrint () {



    },
    getSubjectTreeList (data) {
      this.api.getSubjectCourseTreeListPaperDetail(data)
        .then(result => {
          console.log(result)
          this.studyDataList = result.data.records
          // for (let item of result.data) {
          //   if (item.children.length != 0) {
          //     for (let items of item.children) {
          //       if (items.children.length != 0) {
          //         for (let itemss of items.children) {
          //            delete itemss.children;
          //         }
          //       } else {
          //         // delete items.children;
          //       } 
          //     }
          //   } else {
          //     // delete item.children;
          //   }
          // }
        })
        .catch(error => {
          console.log(error)
        });
    },
    //获取列表
    // getSubjectTreeListTestTime() {
    //   this.api.getSubjectCourseTreeListTestTime(this.paperList).then(result => {
    //       console.log(result)
    //       this.subjectTreeList=result.data
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     })
    // },
    studySizeChange (pageSize) {
      this.studySearch.pageSize = pageSize;
    },
    studyCurrentChange (pageNumber) {
      this.studySearch.pageNumber = pageNumber;
    },
    addAgentRoleInfo () {
      this.$router.push({ path: "/paperPrint" });
    },
    editPaper (index) {
      this.addFormVisiblePaper = true
      this.editCouseid = index.row.id
      this.editPaperData.id = index.row.id
    },
    sendMessage (index, value) {
      console.log(value)
      this.addFormVisible = true
      this.noticeNum = 1
      var NoticeArr = []
      NoticeArr.push(value.mobile)
      this.massCouseNoticeInfoList.mobiles = NoticeArr
      // console.log(this.massCouseNoticeInfoList)
    },
    submitNotice (data) {
      this.api.getSubjectCourseTreeListMassNotice(data).then(result => {
        console.log(result)
        if (result.code == 200) {
          this.$message({
            message: '批量通知成功',
            type: 'success'
          });
          this.loading = false;
          this.addFormVisiblePaper = false
        }
      })
    },
    //请求通知
    submitPaper () {
      // this.massCouseNoticeList.remark = this.massNotice
      // this.massCouseNoticeInfoList.remark = this.massNotice
      console.log(this.massCouseNoticeInfoList)
      console.log(this.massCouseNoticeList)
      if (this.noticeNum == 1) {
        this.submitNotice(this.massCouseNoticeInfoList)
      } else {
        this.submitNotice(this.massCouseNoticeList)
      }
    },
    cancel () {
      this.addFormVisiblePaper = false
    },
    //请求领取
    addSubmit () {
      //请求     
      console.log(this.multipleSelection)
      console.log(this.radio)
      var arr = []
      this.multipleSelection.forEach((value, index) => {
        value['collectionType'] = this.radio
      })
      this.api.getSubjectCourseTreeListMassRevice(this.multipleSelection).then(result => {
        if (result.data.length == 0) {
          this.loading = false;
        } else {
          this.addFormVisible = false
          this.$message({
            message: '批量领取成功',
            type: 'success'
          });
        }
      })
        .catch(error => {
          console.log(error);
        })
    },
    resetCancel () {
      this.addFormVisible = false
    },
    findData () {
      //请求
      this.valueList.likename = this.input2
      console.log(this.valueList)
      this.getSubjectTreeList(this.valueList)

    },
    handleSelectionChange (val) {
      this.dataList = val
      console.log(val)
      var arr = []
      var NoticeArr = []
      this.dataList.forEach(function (value, index, array) {
        arr.push({ "id": value.id })
        NoticeArr.push(value.mobile)
      })
      this.multipleSelection = arr;
      this.massCouseNoticeList.mobiles = NoticeArr
      console.log(this.massCouseNoticeList.mobiles)
    }
  },
  watch: {
    value2 (value) {
      console.log(value);
      console.log(value[0]);
      console.log(value[1]);
      this.startTime = value[0];
      this.endTime = value[1];
      // this.allTime=this.startTime+'至'+this.endTime
      // console.log(this.allTime)
      this.editPaperData.collectionTime = this.startTime + '至' + this.endTime
    }
  },
  mounted () {
    this.valueList.examinationSettingId = this.$route.query.id;
    console.log(this.$route.query.id)
    this.getSubjectTreeList(this.valueList);
  }
}
</script>
<style scoped>
.classStudy-button {
  float: right;
}
.classStudy-table {
  margin-top: 20px;
}
.paperManger {
  display: flex;
}
.classStudy-header {
  position: absolute;
  right: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/testSystem/paperCollectionDetail.vue